/**
 * this is used to sort and get the most current price by date
 * @param {*} prices
 */
const getCurrentPrice = (prices = []) => {
  // sort prices by date in decreasing order of date
  prices.sort((price1, price2) => {
    if (price2.date > price1.date) {
      return 1
    }
    if (price2.date < price1.date) {
      return -1
    }

    return 0
  })

  return prices[0] || {} // just incase prices[0] is undefined
}

const findProduct = (products = [], productName, options = {lookBehind: false}) => {
  const where = product => (product.name === productName) || (options.lookBehind && product.oldNames && product.oldNames.find(oldName => oldName.name === productName))
  const product = products.find(where)
  return product
}

module.exports = {
  getCurrentPrice,
  findProduct
}



// WEBPACK FOOTER //
// ./src/products/utils.js